import LazyImg from "../components/Library/LazyImage";

import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, Collapse, Spin } from "antd";
import { Navigation, Keyboard } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { LoadingOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";
import { Helmet } from "react-helmet";

import axiosInstance from "../config/axios-instance";
import placeholder_jeans from "../img/placeholder_jeans.svg";

import "swiper/swiper.min.css";
import "swiper/modules/navigation/navigation.min.css";

const { Meta } = Card;
const { Panel } = Collapse;

interface Props {}

export const RepsonsibleChoice = (props: Props) => {
  const [responsible, setResponsible] = useState<Array<any>>([]);

  const fetchResponsibleChoice = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/responsible_choice`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => {
      setResponsible(res.data);
    });
  };

  const { isLoading } = useQuery(
    ["responsible_choice"],
    fetchResponsibleChoice,
    { keepPreviousData: true }
  );
  return isLoading ? (
    <div className="loading_orders">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <>
      <Helmet>
        <title>Responsible choice</title>
      </Helmet>
      <div className="products_page_container">
        <div className={`container-fluid `}>
          <div style={{ padding: "25px" }}>
            <div>
              <div>
                {responsible &&
                  responsible.map((el: any, index: number) => {
                    return (
                      <div key={el.id || index}>
                        {el && el.products.length > 0 ? (
                          <>
                            <div
                              className="row row-responsible-choice"
                            >
                              <div
                                className="col-12 col-md-4 p-md-2"
                                style={{ textAlign: "left" }}
                              >
                                <h1 className={"h1_reponsible_choice"}>
                                  {el.name}
                                </h1>
                                <div
                                  style={{
                                    wordWrap: "break-word",
                                    opacity: "1",
                                  }}
                                  className="paragraphe product_description_reponsible"
                                  dangerouslySetInnerHTML={{
                                    __html: el.description || "No description",
                                  }}
                                ></div>
                              </div>
                              <div
                                className="col-12 col-md-8"
                                style={{ wordWrap: "break-word" }}
                              >
                                {" "}
                                <div>
                                  {/*  <div key={el.id}>
                                                                                        <MySlider products={el.products} />
                                                                                    </div>*/}

                                  <Swiper
                                   modules={[Navigation, Keyboard]} // Pass the modules here
                                   slidesPerView={4}
                                   spaceBetween={30}
                                   navigation={true} // Enable navigation
                                   keyboard={true} // Enable keyboard navigation
                                    className="mySwiper"
                                    breakpoints={{
                                      320: { slidesPerView: 1, spaceBetween: 10 },
                                      640: { slidesPerView: 2, spaceBetween: 20 },
                                      768: { slidesPerView: 3, spaceBetween: 25 },
                                      1024: { slidesPerView: 4, spaceBetween: 30 },
                                    }}
                                    style={{ overflow: "hidden" }}
                                  >
                                    {el?.products.map(
                                      (prod: any, index: number) => {
                                        return (
                                          <SwiperSlide key={prod.id || index} className="sliderHeight">
                                              <div
                                                style={{
                                                  textAlign: "center",
                                                  width: "250px",
                                                }}
                                              >
                                                <Link
                                                  to={`/product/details/${prod.fabric}/${prod.gendre}/${prod.category}/${prod.name}/${prod.id}`}
                                                  style={{
                                                    textAlign: "center",
                                                    color: "#182844",
                                                  }}
                                                >
                                                  <LazyImg
                                                    src={
                                                      prod.front_image
                                                        ? process.env
                                                            .REACT_APP_STORAGE_URL +
                                                          prod.front_image
                                                        : placeholder_jeans
                                                    }
                                                    style={{
                                                      width: "270px",
                                                      height: "300px",
                                                    }}
                                                  />
                                                  <p
                                                    style={{
                                                      fontSize: "12px",
                                                      textAlign: "center",
                                                      textTransform:
                                                        "capitalize",
                                                    }}
                                                  >
                                                    {prod.code} <br />
                                                    {prod.name}
                                                    <>
                                                      {prod.gender_id == 2 ? (
                                                        <>-Women</>
                                                      ) : prod.gender_id ==
                                                        1 ? (
                                                        <>-Men</>
                                                      ) : prod.gender_id ==
                                                        3 ? (
                                                        <>-Unisex</>
                                                      ) : prod.gender_id ==
                                                        4 ? (
                                                        <>-Kids</>
                                                      ) : prod.gender_id ==
                                                        5 ? (
                                                        <>-Boys</>
                                                      ) : prod.gender_id ==
                                                        6 ? (
                                                        <>-Girls</>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </>
                                                  </p>
                                                </Link>
                                              </div>
                                            </SwiperSlide>
                                        );
                                      }
                                    )}
                                  </Swiper>
                                  {/*   <div
                                                                                    style={{
                                                                                        marginTop: "20px",
                                                                                        textAlign: "right",
                                                                                    }}
                                                                                >
                                                                                    <Link
                                                                                        to={
                                                                                            "/responsible/" +
                                                                                            el.id +
                                                                                            "/" +
                                                                                            el.fabric_type +
                                                                                            "/" +
                                                                                            el.name
                                                                                        }
                                                                                        className="btn"
                                                                                    >
                                                                                        See more
                                                                                    </Link>
                                                                                </div>*/}
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
